import { render, staticRenderFns } from "./vouchers.vue?vue&type=template&id=e5b604e0&scoped=true&lang=html&"
import script from "./vouchers.vue?vue&type=script&lang=js&"
export * from "./vouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b604e0",
  null
  
)

export default component.exports